import { render } from "./professionKnowledgeManager.vue?vue&type=template&id=e2b1d2d4"
import script from "./professionKnowledgeManager.vue?vue&type=script&lang=js"
export * from "./professionKnowledgeManager.vue?vue&type=script&lang=js"

import "./professionKnowledgeManager.vue?vue&type=style&index=0&id=e2b1d2d4&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__